import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import type { AuthState } from 'flaivy-react/types';

function RequiresLogin({
  authentication,
  children,
}: {
  authentication: AuthState;
  children: any;
}) {
  if (!children) return <></>;

  if (authentication.isAuthenticated && authentication.sessionUser) {
    return children;
  }
  return <></>;
}

const mapStateToProps = ({
  authentication,
}: {
  authentication: AuthState;
}) => ({ authentication });

export default connect(mapStateToProps)(RequiresLogin);
